import React from "react";
const Faq = React.lazy(() => import('./Faq'));

export const faqConfig = [
    {
        path:'/faq',
        element:<Faq />
    }
]